import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { rolesAllAdd, permissionsList } from '../../../api/list'
import DocTable from '../../../components/DocTable'
import DocAdd from '../../../components/DocAdd'
import { loadAutocompliteAPI, initialAutocomplite, clearAutocomplite } from '../../../reducers/autocomplite'
import * as actions from '../../../reducers/form';

const formName = 'addRoleAll'
const arrPermission = 'permission'

export default function RolesAdd() {
  const history = useHistory()
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(actions.formInitialize({ byId: {}, allIds: [], name: '' }, { name: formName }))
    dispatch(initialAutocomplite({ field: arrPermission }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
      dispatch(clearAutocomplite(arrPermission))
    }
  }, [dispatch])
  useEffect(() => {
    dispatch(loadAutocompliteAPI(permissionsList.path, {
      field: arrPermission,
      value: 'id',
      labelFunc: (obj) => obj.slug+' '+obj.label,
      hidden: [],
    }))
  }, [dispatch])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const { values } = form
  const saveServer = () => {
    let arr = []
    values.allIds.forEach(row => {
      const obj = values.byId[row]
      arr.push(obj.idPermission)
    });
    dispatch(actions.formSubmitAPI({
      props: {
        permissions: arr,
        name: values.name,
      },
      url: rolesAllAdd.path,
      method: rolesAllAdd.type,
      history: history
    }, formName))
  }
  return <div className='App-paper'>
    <DocAdd
      formName={formName}
      history={history}
      title='Добавить роль'
      noTableProps={[
        { field: 'name', label: 'Наименование', type: 'text', textProps: { type: 'text' } },
      ]}
      handleSave={saveServer}
    >
      <DocTable
        formName={formName}
        column={[
          {
            id: 'valuePermission', type: 'auto', name: 'Разрешения', formArr: arrPermission,
            filtered: true, changeValue: e => ({
              idPermission: e.value,
              valuePermission: e,
            }),
          },
        ]}
        rowDefault={{
          idPermission: '',
          valuePermission: null,
        }}
      />
    </DocAdd>
  </div>
}